import usingServiceAdvantage from './usingKoreanBBQAdvantage';
import frequentlyAskedQuestions from './koreanbbq-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Korean Restaurant POS System',
      description: `Fire up the guest experience with the industry's top Korean Restaurant POS System!`,
    },
    zh: {
      title: '韩国烤肉',
      description: '善用POS为您的顾客提供更好的服务，赚取更高的利润',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended Products for Korean BBQ Restaurants',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
